import React from 'react';
import '../ui.css';

const AlertChip = ({ label, valor, tono = 'rojo', onClick, ayuda }) => {
    return (
        <span
            className={`ui-chip ui-chip--${tono}`}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onClick={onClick}
            onKeyDown={onClick ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}
            title={ayuda}
        >
            {label} <strong>{valor}</strong>
        </span>
    );
};

export default AlertChip;
